
import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import BrownianMotion from './BrownianMotion';
import { useIsMobile } from '@/hooks/use-mobile';
import { useLocation } from 'react-router-dom';

interface PageLayoutProps {
  children: React.ReactNode;
  className?: string;
}

const PageLayout = ({ children, className = "" }: PageLayoutProps) => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const [isLoaded, setIsLoaded] = useState(false);
  
  // Ensure content only fades in once, not on every rerender
  useEffect(() => {
    setIsLoaded(false);
    
    // Use a more reliable timeout approach
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100); // Slightly longer delay for more reliable transitions
    
    return () => clearTimeout(timer);
  }, [location.pathname]);
  
  return (
    <div 
      className={`min-h-screen flex flex-col bg-delphi-dark text-delphi-light ${className}`}
    >
      <Navbar />
      
      <div className="flex-grow relative">
        <div className="absolute inset-0 z-0 overflow-hidden">
          <BrownianMotion 
            particleCount={isMobile ? 2 : 3} 
            speed={0.3} 
            trailLength={120}
          />
        </div>
        <main 
          className={`relative z-10 transition-opacity duration-500 ease-in-out ${isLoaded ? 'opacity-100' : 'opacity-0'}`}
        >
          {children}
        </main>
      </div>
      
      <Footer />
    </div>
  );
};

export default PageLayout;
